module.exports = __webpack_public_path__ + "img/icono-header-btn-contacto.47548293.svg";